import { bus } from '../engine/EventBus';
import { save } from '../engine/SaveSystem';

export class HUD {
  private coinEl: HTMLElement;
  private secretEl: HTMLElement;
  private hintEl: HTMLElement;
  private totalSecrets = 10;
  private root: HTMLElement;

  constructor(root: HTMLElement, totalSecrets: number) {
    this.root = root;
    this.totalSecrets = totalSecrets;

    const bl = document.createElement('div');
    bl.className = 'hud bottom-left';
    this.coinEl = document.createElement('div');
    this.coinEl.className = 'hud-chip';
    this.secretEl = document.createElement('div');
    this.secretEl.className = 'hud-chip';
    bl.appendChild(this.coinEl);
    bl.appendChild(this.secretEl);
    root.appendChild(bl);

    const br = document.createElement('div');
    br.className = 'hud bottom-right';
    this.hintEl = document.createElement('div');
    this.hintEl.className = 'hud-hint';
    this.hintEl.style.display = 'none';
    br.appendChild(this.hintEl);
    root.appendChild(br);

    this.refresh();
    bus.on('coins:changed', () => this.refresh());
    bus.on('secret:collected', () => this.refresh());
    bus.on('character:changed', () => this.refresh());
    bus.on('hint:set', ({ text }) => this.setHint(text));
  }

  setTotalSecrets(n: number) { this.totalSecrets = n; this.refresh(); }

  show(visible: boolean): void {
    this.root.querySelectorAll('.hud').forEach((el) => {
      (el as HTMLElement).style.display = visible ? 'flex' : 'none';
    });
  }

  private refresh(): void {
    this.coinEl.innerHTML = `<span class="emoji">🪙</span><span>${save.data.coins}</span>`;
    this.secretEl.innerHTML = `<span class="emoji">✨</span><span>${save.data.collectedSecrets.length} / ${this.totalSecrets}</span>`;
  }

  private setHint(text: string | null): void {
    if (!text) {
      this.hintEl.style.display = 'none';
    } else {
      this.hintEl.textContent = text;
      this.hintEl.style.display = 'block';
    }
  }
}
